import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import RemoveFromBatchButton from './index';
import { removeFulfillmentPlansFromBatch } from '../../../store/batches/details/batch.details.actions';

const mapStatesToProps = (state) => {
  const { fulfillmentPlanSetId } = Global.selectBatchDetailsBatch(state);
  const selectedGridFulfillmentPlanIds = Global.selectSelectedOrdersIds(state);

  return {
    fulfillmentPlanSetId,
    selectedGridFulfillmentPlanIds,
    disabled: selectedGridFulfillmentPlanIds.length === 0,
  };
};

const dispatchProps = (dispatch) => {
  return {
    onClick: (fulfillmentPlanSetId, selectedGridFulfillmentPlanIds) => {
      dispatch(
        removeFulfillmentPlansFromBatch({
          fulfillmentPlanSetId,
          fulfillmentPlanIds: selectedGridFulfillmentPlanIds,
        }),
      );
    },
  };
};

export default connect(mapStatesToProps, dispatchProps)(RemoveFromBatchButton);
